import React from 'react'
import classNames from 'classnames'

import styles from '@components/pages/sms/sms_form_message.module.scss'

const FormMessage = ({ message, children, colorClass }) => (
  <div className={classNames(styles.form_message, colorClass)}>
    <div className={styles.form_message__content}>
      <div className={styles.form_message__icon}>{children}</div>
      <p className={styles.form_message__message}>{message}</p>
    </div>
  </div>
)

export { FormMessage }
